import React, { useState } from "react";
import { Table, Button, Modal, Form, Input, Space, Select } from "antd";
import inputStyles from "../../../../../styles/Custom/Input.module.css";
import { finalGrade, initialGrade, pressureSoreKeys } from "../../formsKeys";

const PressureSoreTable = ({ setPressureSorePoints, pressureSorePoints }) => {
  const [isModalOpen, setIsModalOpen] = useState(false);
  const [formData, setFormData] = useState([]); // Array to store submitted form data
  const [form] = Form.useForm();

  const columns = [
    {
      title: "Pressure Sore",
      dataIndex: "pressureSore",
      key: "pressureSore",
      render: (value) =>
        pressureSoreKeys?.map((pres) =>
          pres?.value === value ? pres?.label : null
        ),
    },
    {
      title: "Initial Grade",
      dataIndex: "initial_grade",
      key: "initial_grade",
    },
    {
      title: "Final Grade",
      dataIndex: "final_grade",
      key: "final_grade",
    },
  ];

  const handleOpenModal = () => {
    setIsModalOpen(true);
  };

  const handleCancel = () => {
    setIsModalOpen(false);
    form.resetFields(); // Reset the form on modal close
  };

  const handleSubmit = (values) => {
    // Append new form data to the existing array
    setFormData((prev) => [...prev, values]);
    setPressureSorePoints((prev) => (prev ? [...prev, values] : values));
    setIsModalOpen(false); // Close modal
    form.resetFields(); // Reset form fields
  };
  // console.log(pressureSorePoints, "pressureSorePoints");
  return (
    <>
      <Button type="primary" onClick={handleOpenModal} ghost>
        Add Pressure Sore
      </Button>
      <Table
        dataSource={
          pressureSorePoints?.length > 0 &&
          pressureSorePoints?.map((item, index) => ({
            key: index,
            ...item,
          }))
        }
        pagination={false}
        columns={columns}
        style={{ marginTop: 20 }}
      />
      <Modal
        title="Add Pressure Sore Details"
        visible={isModalOpen}
        onCancel={handleCancel}
        footer={null} // Custom footer handled by the form
      >
        <Form form={form} layout="vertical" onFinish={handleSubmit}>
          <Form.Item
            label="Pressure Sore"
            name="pressureSore"
            rules={[{ required: true, message: "Please enter pressure sore" }]}
          >
            <Select
              options={pressureSoreKeys}
              className={inputStyles.mdInput}
              style={{ width: "250px" }}
            />
          </Form.Item>
          <Form.Item
            label="Initial Grade"
            name="initial_grade"
            rules={[{ required: true, message: "Please enter initial grade" }]}
          >
            <Select
              options={initialGrade}
              className={inputStyles.mdInput}
              style={{ width: "250px" }}
            />
          </Form.Item>
          <Form.Item
            label="Final Grade"
            name="final_grade"
            rules={[{ required: true, message: "Please enter final grade" }]}
          >
            <Select
              options={finalGrade}
              className={inputStyles.mdInput}
              style={{ width: "250px" }}
            />
          </Form.Item>
          <Space>
            <Button onClick={handleCancel}>Cancel</Button>
            <Button type="primary" htmlType="submit">
              Submit
            </Button>
          </Space>
        </Form>
      </Modal>
    </>
  );
};

export default PressureSoreTable;
